import { PaginatedReviewResponse } from '@/types/api'
import { ReviewResponse } from '@/types/collection'

import { reviewFormatter } from '../formatter/__f.review'
import { httpClient } from './http-client'

export const __cHighlightProductService = {
  /**
   * Lấy reviews của product cho highlight product page
   * Không sử dụng URLSearchParams, chỉ nhận productId
   */
  getReviews: async (productId: string) => {
    const response = await httpClient.V1.get<
      PaginatedReviewResponse<ReviewResponse>
    >(`/reviews/filter?current_product_id=${productId}`)

    const formattedReview = reviewFormatter.formatReviewPaginated(response)

    return formattedReview
  },
}
